module.exports = __webpack_public_path__ + "img/tiptip-white-sm.ba9f7498.png";